import * as Schema from "effect/Schema";
import { PlanFeatures } from "./planSettings.js";
export const PolicyResource = Schema.Literals(["network"]);
export const UnavailableCause = Schema.Literals(["offline", "plan"]);
export const ResourceAvailability = Schema.Union([
    Schema.Struct({ status: Schema.Literal("available") }),
    Schema.Struct({
        status: Schema.Literal("unavailable"),
        cause: UnavailableCause,
    }),
]);
export const PolicyActionId = Schema.Literals([
    "turn.start",
    "turn.deepWork",
    "project.create",
    "voice.transcribe",
    "basa.open",
]);
export const ACTION_REQUIREMENTS = {
    "turn.start": { resources: ["network"] },
    "turn.deepWork": { resources: ["network"], feature: "deepWork" },
    "project.create": { resources: [] },
    "voice.transcribe": { resources: ["network"], feature: "voiceInput" },
    "basa.open": { resources: ["network"] },
};
export const PolicyState = Schema.Struct({
    resources: Schema.Struct({
        network: ResourceAvailability,
    }),
    features: PlanFeatures,
});
export const PolicyDecision = Schema.Union([
    Schema.Struct({ allowed: Schema.Literal(true) }),
    Schema.Struct({
        allowed: Schema.Literal(false),
        cause: UnavailableCause,
        resource: Schema.optionalKey(PolicyResource),
    }),
]);
export function decide(action, state) {
    const requirement = ACTION_REQUIREMENTS[action];
    if ("feature" in requirement && !state.features[requirement.feature]) {
        return { allowed: false, cause: "plan" };
    }
    for (const resource of requirement.resources) {
        const availability = state.resources[resource];
        if (availability.status === "unavailable") {
            return {
                allowed: false,
                cause: availability.cause,
                resource,
            };
        }
    }
    return { allowed: true };
}
export const PolicyCapabilities = Schema.Struct({
    "turn.start": PolicyDecision,
    "turn.deepWork": PolicyDecision,
    "project.create": PolicyDecision,
    "voice.transcribe": PolicyDecision,
    "basa.open": PolicyDecision,
});
export function capabilitiesFor(state) {
    return {
        "turn.start": decide("turn.start", state),
        "turn.deepWork": decide("turn.deepWork", state),
        "project.create": decide("project.create", state),
        "voice.transcribe": decide("voice.transcribe", state),
        "basa.open": decide("basa.open", state),
    };
}
export const allResourcesAvailable = {
    network: { status: "available" },
};
